import React from 'react';
import useInputValidation, { IInputValitationResponse } from '../../../hooks/input-validation-hook';
import FontBody4 from '../../fonts/font-body4/font-body4';
import './textarea.scss';
import InputErrorMessages from '../input-error-messages/input-error-messages';
import { IValidationProps } from '../input/input';

export enum TEXTAREA_VARIANTS {
	DEFAULT = 'default',
	FIT_CONTENT = 'fit-content',
}

interface ITextareaProps extends IValidationProps {
	placeholder?: string,
	value?: string;
	onChange?: (value: any) => void;
	disabled?: boolean;
	maxLength?: number;
	showCharactersCount?: boolean;
	variant?: TEXTAREA_VARIANTS,
}

export const Textarea: React.FC<ITextareaProps> = ({ 
	value, placeholder, onChange, disabled, required, maxLength, showCharactersCount, validationGroup, validationCallback, showValidationMessage, variant = TEXTAREA_VARIANTS.DEFAULT
}) => {
    const { isValid, messages } = useInputValidation({ value, validation: { validationGroup, required, validationCallback, showValidationMessage } });

	const adjustTextareaSize = (e:React.ChangeEvent<HTMLTextAreaElement>) => {
		if (variant === TEXTAREA_VARIANTS.FIT_CONTENT) {
			const target = e.target;
			target.style.height = "17px";
			target.style.height = (target.scrollHeight) + "px";
		}
	}

	const handleOnChange = (e:React.ChangeEvent<HTMLTextAreaElement>) => {
		adjustTextareaSize(e);

		const value = e.target.value;

		onChange && onChange(value);
	}

	return(
        <>
		<div className={`textarea ${variant}`}>
			<textarea className={`${ !isValid ? 'invalid' : ''}`}
				disabled={disabled}
				placeholder={placeholder}
				onChange={handleOnChange} 
				value={value ?? ''} 
				maxLength={maxLength}
			/>
			{showCharactersCount &&
				<div className="letter-count">
					<FontBody4>
						{(value ?? '').length}
						{!!maxLength &&
							<> / {maxLength}</>
						}
					</FontBody4>
				</div>
			}
		</div>
        <InputErrorMessages messages={messages} />
        </>
	)
};
